import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, role }) {
  const { user, loading } = useAuth();

  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FDFDFC]">
        <div className="w-10 h-10 border-2 border-[#1B2A4A] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/connexion" replace />;
  if (role && user.role !== role && user.role !== "admin") {
    const home = user.role === "seller" ? "/vendeur" : "/dashboard";
    return <Navigate to={home} replace />;
  }
  return children;
}
